import { type ReactNode } from "react";
import { Home, BookOpen, Brain, Flame, Trophy, Layers } from "lucide-react";
import { FloatingDock } from "@/components/aceternity/floating-dock";
import { SiteNav } from "@/components/site-nav";
import { SiteFooter } from "@/components/site-footer";

export type Surface = "marketing" | "app" | "auth";

const DOCK_ITEMS = [
  { title: "Home",        href: "/dashboard",   icon: <Home     className="w-5 h-5" /> },
  { title: "Levels",      href: "/learn",       icon: <Layers   className="w-5 h-5" /> },
  { title: "Quiz",        href: "/quiz",        icon: <Brain    className="w-5 h-5" /> },
  { title: "Streak",      href: "/streak",      icon: <Flame    className="w-5 h-5" /> },
  { title: "Leaderboard", href: "/leaderboard", icon: <Trophy   className="w-5 h-5" /> },
  { title: "Learn",       href: "/learn",       icon: <BookOpen className="w-5 h-5" /> }
];

export function PageFrame({ surface, children, hideFooter = false, hidePointsPill = false }: { surface: Surface; children: ReactNode; hideFooter?: boolean; hidePointsPill?: boolean }) {
  return (
    <div className="min-h-screen flex flex-col bg-bg text-fg">
      {surface === "marketing" && <SiteNav hidePointsPill={hidePointsPill} />}
      <main className="flex-1">{children}</main>
      {surface === "app" && <FloatingDock items={DOCK_ITEMS} />}
      {surface === "marketing" && !hideFooter && <SiteFooter />}
    </div>
  );
}
